// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model, Q } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import relation from '@nozbe/watermelondb/decorators/relation';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';

setGenerator(uuidv4);

export default class InventoryChange extends Model {
    static table = 'inventory_changes';

    static associations = {
        inventoryProducts: { type: 'belongs_to', key: 'inventory_product_id' },
        users: { type: 'belongs_to', key: 'user_id' },
        organisations: { type: 'belongs_to', key: 'organisation_id' },
    };

    @field('inventory_product_id') inventoryProductId;
    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @field('quantity_change') quantityChange;

    @date('process_at') processAt;

    @readonly @date('client_created_at') clientCreatedAt;
    @readonly @date('client_updated_at') clientUpdatedAt;
    @readonly @date('archived_at') archivedAt;
    @readonly @date('created_at') createdAt;
    @readonly @date('updated_at') updatedAt;

    @relation('inventory_products', 'inventory_product_id') inventoryProduct;
    @relation('users', 'user_id') user;
    @relation('organisations', 'organisation_id') organisation;
}

export type InventoryChangeSimple = {
    id: string;
    inventoryProductId: string;
    userId: string;
    organisationId: string;
    quantityChange: number;
    clientCreatedAt: number;
    clientUpdatedAt: number;
    archivedAt: number;
    createdAt: number;
    updatedAt: number;
    processAt: number;
};
